import { defineNuxtPlugin } from '@nuxtjs/composition-api'

export default defineNuxtPlugin(({ app, store }) => {
  app.router.afterEach((to) => {
    store.commit('navigation/setRoute', to)
  })
})
